import { axiosInstance } from "api/axios";
import { encryptForCompany } from "./encryptForCompany";
import encryptContent from "./encryptString";
import { readAsBase64 } from "./readAsBase64";

// F3 (docs/model-kluczy-firmowych.md, rozstrzygnięcie 5 sekcji 4 + inwariant I1): notatki
// były JEDYNĄ treścią szyfrowaną WPROST kluczem publicznym profilu (Notes nie miało żadnej
// kolumny klucza — SHOW COLUMNS FROM Notes). Podmiana samego klucza (profil -> firma) bez
// klucza obiektu przypięłaby każdą notatkę do jednej generacji klucza firmy na zawsze —
// rotacja nie miałaby czego przewijać, a odebranie grantu firmie nie dałoby się cofnąć bez
// utraty notatek. Notes.EncryptionKeyId (db-migrations/2026-09-08_claude_f3_02_notes_encryption_key.sql)
// domyka tę lukę tak samo, jak Contract/CaseFile mają swój EncryptionKeyId dla plików.
//
// Był TRZY RAZY ten sam kod (AddNote/index.tsx, AddNote/AddNoteForm.tsx,
// modules/deskModule/index.tsx#encryptForProfile) — ten util je zastępuje.
//
// Klucz obiektu jest ŚWIEŻY przy KAŻDYM wywołaniu — przy tworzeniu I przy każdej edycji —
// dokładnie jak dotychczasowe pełne re-szyfrowanie całej treści na starej ścieżce (profil).
// Dzięki temu nie trzeba doczytywać z serwera klucza publicznego notatki sprzed edycji;
// stary wiersz ObjectKeys zostaje po prostu nieużywany, tak samo jak ginęła stara treść.
//
// FAIL-CLOSED: brak aktywnego klucza firmy RZUCA `CompanyKeyMissingError` (encryptForCompany.ts)
// zamiast po cichu zapisać notatkę, której żaden inny członek firmy nie odczyta.

export interface IEncryptedNoteFields {
  Title: string;
  Content: string;
  EncryptionKeyId: string;
}

export const encryptNoteFields = async (
  title: string,
  content: string,
): Promise<IEncryptedNoteFields> => {
  const objectKey = await encryptForCompany();

  // Wzorem uploadCompanyEncryptedFile / uploadFile.handleCreate: klucz obiektu zakładany
  // PRZED szyfrowaniem treści, ta sama para (PublicKey do szyfrowania, PrivateKey do zapisu).
  const { data } = await axiosInstance.post<{ Id: string }>("/keys/object", {
    CaseId: null,
    PrivateKey: objectKey.PrivateKey,
    PublicKey: objectKey.PublicKey,
  });

  const [encryptedTitle, encryptedContent] = await Promise.all([
    encryptContent(title, objectKey.cleanPublicKey),
    encryptContent(content, objectKey.cleanPublicKey),
  ]);

  const [Title, Content] = await Promise.all([
    readAsBase64(encryptedTitle),
    readAsBase64(encryptedContent),
  ]);

  return { Title, Content, EncryptionKeyId: data.Id };
};

export default encryptNoteFields;
